enum ApiProtocol {
    Mqtt = "Mqtt",
    Fake = "Fake",
    Simulation = "Simulation",
    Rest = "Rest",
    Relay = "Relay",
    Disabled = "Disabled",
}

export default ApiProtocol;